export default __webpack_public_path__ + "static/cafe_36026-0bac28dad9fc7b4e6b482fb97c6c6c92.png";